import { Typography, TypographyProps } from '@mui/material';

const Subtitle = ({ children, ...props }: TypographyProps) => (
  <Typography variant="subtitle1" sx={{ mb: 6 }} {...props}>
    {children}
  </Typography>
);

export default Subtitle;
